import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["category", "content"];

    connect() {
        this.initializeIconArrows();
        this.setupDetailsListeners();
    }

    selectCategory(event) {
        const selectedCategory = event.currentTarget.dataset.category;

        this.categoryTargets.forEach((category) => {
            category.classList.remove("active");
        });

        event.currentTarget.classList.add("active");

        this.contentTargets.forEach((content) => {
            if (content.dataset.category === selectedCategory) {
                content.classList.remove("d-none");
            } else {
                content.classList.add("d-none");
            }
        });
    }

    initializeIconArrows() {
        // Set initial icon arrow states based on details open attribute
        this.contentTargets.forEach((content) => {
            const detailsElements = content.querySelectorAll('details');
            detailsElements.forEach((details) => {
                this.updateIconArrow(details);
            });
        });
    }

    setupDetailsListeners() {
        // Add event listeners to all details elements
        this.contentTargets.forEach((content) => {
            const detailsElements = content.querySelectorAll('details');
            detailsElements.forEach((details) => {
                details.addEventListener('toggle', () => {
                    this.updateIconArrow(details);
                });
            });
        });
    }

    updateIconArrow(detailsElement) {
        const iconArrow = detailsElement.querySelector('.icon-arrow');
        if (iconArrow) {
            if (detailsElement.hasAttribute('open')) {
                iconArrow.textContent = '-';
            } else {
                iconArrow.textContent = '+';
            }
        }
    }
}